// eslint-disable-next-line
__webpack_public_path__ = window.resourceBasePath || "";
